import { CURRENCY_CONVERSION_CONFIG } from "lookup";
import api from "apiSingleton";

export const convertSalaryToRatePerHour = (salary) => {
  return parseFloat((salary / 2080).toFixed(0));
};

export const baseToTargetCurrency = (
  baseValue,
  conversionCurrencyValue,
  internationalFormatText = true,
  intFormat = "en-IN",
  isInteger = true
) => {
  let value;
  if (isInteger) {
    value = parseInt(
      Math.floor(baseValue / conversionCurrencyValue).toFixed(2)
    );
  } else {
    value = Number((baseValue / conversionCurrencyValue).toFixed(2));
  }

  if (internationalFormatText) {
    return new Intl.NumberFormat(intFormat).format(value);
  }

  return value;
};

export const loggedUserShouldINRConvert = (loggedInUser) => {
  return (
    CURRENCY_CONVERSION_CONFIG.exchangeFactor &&
    loggedInUser.company &&
    CURRENCY_CONVERSION_CONFIG.companyNames?.includes(loggedInUser.company)
  );
};

export const getUserName = (user) => {
  return user?.username || user?.identity_username || "";
};

export const getPlatformProfileUrl = (username) => {
  return `${process.env.REACT_APP_DOMAIN}/#/profile/${encodeURIComponent(
    username
  )}`;
};

export const getUserDataForEdit = async (email) => {
  const userData = await api.user.getForEditByEmail({
    email: email,
  });
  if (userData.data?.getUserByEmail?.items?.length > 0) {
    return userData.data?.getUserByEmail?.items?.[0];
  }
  return null;
};
